import { Container, Content, Heading, Level, Notification } from 'react-bulma-components';
import React, { useEffect, useState } from 'react';
import { majorKey, minorKey } from '../lib/transposeKey';

import { Form } from 'react-bulma-components';
import Markdown from '../components/markdown';

const { Select } = Form;

const PracticeContent = ({ title, description, org_keytonic, keytonic, skipInstrumentTransponation, allowUserKey, isPreview }) => {
  const left = { textAlign: 'left' };
  const [userKey, setUserKey] = useState(keytonic);
  useEffect(() => {
    setUserKey(keytonic);
  }, [keytonic]);
  function handleChangeUserKey(e) {
    setUserKey(e.target.value);
  }

  return (
    <Notification>
      <Level>
        <Level.Side align="left"><Level.Item><Heading size={5} subtitle>
        {title}
      </Heading></Level.Item></Level.Side>
        {allowUserKey===true &&
          <Level.Side align="right"><Level.Item><Heading size={5} subtitle mr={2}>
           Change key: </Heading>
          <Select
              name="selectUserKey"
              value={userKey}
              onChange={handleChangeUserKey}
              disabled={isPreview}
            >
          {userKey && userKey.endsWith('m') ? minorKey.map(key => (
            <option key={key} value={key}>{key}</option>
          )) : majorKey.map(key => (
            <option key={key} value={key}>{key}</option>
          ))}
        </Select>
        </Level.Item></Level.Side>
        }
{/*         <Level.Side align="right"><Level.Item><Heading size={5} subtitle>
          Done!
        </Heading></Level.Item></Level.Side> */}
      </Level>
      <Container>

        {description &&
          <Content>
            {/* org_keytonic: {org_keytonic}, keytonic: {keytonic}, userKey: {userKey}, skipInstrumentTransponation: {skipInstrumentTransponation?.toString()} */}
            <Markdown objectProps={{ org_keytonic: org_keytonic, keytonic: userKey, skipInstrumentTransponation: skipInstrumentTransponation }}>{description}</Markdown>
          </Content>
        }
      </Container>
    </Notification>
  )
}

export default PracticeContent;